'use client';

import { useTranslations } from 'next-intl';
import styles from './error.module.css';
import { Button } from '@/components/ui/button';
import { EmptyState } from '@/components/ui/empty-state';
import { useBoundaryErrorReport } from '@/lib/observability/report-boundary-error';

interface Props {
  error: Error & { digest?: string };
  reset: () => void;
}

export default function RecipeDetailError({ error, reset }: Props) {
  const tc = useTranslations('common');
  const t = useTranslations('recipes.detail');

  useBoundaryErrorReport('recipes/[slug]', error);

  return (
    <div className={styles.wrapper}>
      <EmptyState
        as="h1"
        icon="error"
        headline={tc('error')}
        body={t('errorMessage')}
        action={<Button onClick={reset}>{tc('retry')}</Button>}
      />
    </div>
  );
}
